"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Overlay;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function Overlay(props) {
  if (!props.open) {
    return null;
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "overlay",
    onClick: props.onClick,
    role: "presentation"
  }) // cursor-default
  ;
}

Overlay.propTypes = {
  open: _propTypes.PropTypes.bool.isRequired,
  onClick: _propTypes.PropTypes.func.isRequired
};